import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  TelegramIcon,
  TumblrIcon,
  EmailIcon,
} from "react-share";
import get from "loadsh/get";
import { Box, Typography, Link, List, ListItem } from "@mui/material";
import songStyle from "../../components/SongDetail/styles";
import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";

export default function SocialShareComponent({
  nftLink = false,
  style,
  nftCardUrl = false,
  tokenType = "silver",
  tokenName = false,
  tokenCategory = false,
  tokenPrice = false,
  tokenOwnership = false,
  artistName = "Sunanda Sharma",
  songName = "9-9 Mashukan",
  giftLinkexpire = false,
}) {
  console.log("print nftCardUrl : ", nftCardUrl, nftLink);
  console.log("print refralLink : ", tokenType);
  const [shareUrl, setShareUrl] = useState("");
  const [copied, setCopied] = useState(false);
  const [refLinkText, setRefLinkText] = useState(
    "Get ₹50 on Signup and 20% Cashback using my referral link | Invest in Songs and Own Music | Earn multifold returns"
  );

  const lineOne = `Invest in ${songName} Song by ${artistName} | `;
  const lineTwo = "Own music and earn Royalty Income on FanTiger | ";

  // const goldText = "Also get online listening party, digital signed merchandise and exclusive community access. Check out this Song NFT only at FanTiger."
  // const silveText = "Check out this Song NFT only at FanTiger."
  // const platinumText = "Also get a video call with Sunanda Sharma, merchandise signed & curated by her and more privileges. Check out this Song NFT only at FanTiger "
  const songText =
    "Online listening party with Sunanda and more. Check out this Song at FanTiger ";

  // const telegramtext=  "Invest in 9-9 Mashukan by Sunanda Sharmar | Own music and earn Royalties on FanTiger \n"

  const handleShared = (data) => {
    const tagManagerArgs = {
      dataLayer: {
        event: "tokenShared",
        tokenName: tokenName,
        tokenCategory: tokenCategory,
        tokenPrice: tokenPrice,
        tokenOwnership: tokenOwnership,
        shareMethod: data,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  };

  useEffect(() => {
    if (tokenType == "Silver") {
      setShareUrl(lineOne + "" + lineTwo + "");
    } else if (tokenType == "Gold") {
      setShareUrl(lineOne + "" + lineTwo + "");
    } else if (tokenType == "Platinum") {
      setShareUrl(lineOne + "" + lineTwo + "");
    } else if (tokenType == "song") {
      setShareUrl(lineOne + "" + lineTwo + "" + songText);
    } else if (tokenType == "nftcard") {
      setShareUrl("I am a proud owner of this NFT.");
    } else if (tokenType == "giftRefLink") {
      setShareUrl(
        "NFT waali Diwali!✨🪔" +
          "\n" +
          "\n" +
          "This festive season gift FanTiger exclusive music NFTs💰 and get 1 FREE song NFT." +
          "\n" +
          "\n" +
          "You have received a gift. Accept your Song NFT Gift Now!🎁" +
          "\n" +
          "\n" +
          "This gift link is valid till" +
          " " +
          giftLinkexpire
      );
    } else {
      setShareUrl(refLinkText);
    }
  }, [tokenType]);

  useEffect(() => {
    if ((tokenType = "refralLink")) {
      setRefLinkText(refLinkText);
    } else if (tokenType == "nftcard") {
      setRefLinkText("I am a proud owner of this NFT.");
    } else if (tokenType == "giftRefLink") {
      setRefLinkText(
        "NFT waali Diwali!✨🪔" +
          "\n" +
          "\n" +
          "This festive season gift FanTiger exclusive music NFTs💰 and get 1 FREE song NFT." +
          "\n" +
          "\n" +
          "You have received a gift. Accept your Song NFT Gift Now!🎁" +
          "\n" +
          "\n" +
          "This gift link is valid till" +
          " " +
          giftLinkexpire
      );
    } else {
      setRefLinkText(
        "Invest in 9-9 Mashukan by Sunanda Sharmar | Own music and earn Royalties on FanTiger \n"
      );
    }
  }, [tokenType]);

  const buttonProps = {
    url: nftLink ? nftLink : nftCardUrl,
    quote: shareUrl,
    hashtag: "#FanTiger",
  };

  console.log("buttonPropsSecond text:", shareUrl);
  const buttonPropsSecond = {
    url: nftLink ? shareUrl + "\n" + nftLink : shareUrl + "\n" + nftCardUrl,
  };
  const iconProps = {
    size: 35,
    round: true,
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 500);
    }
  }, [copied]);

  const copyToClipboard = (e) => {
    if (tokenType == "refralLink") {
      navigator.clipboard.writeText(
        nftLink ? refLinkText + "\n" + nftLink : nftCardUrl
      );
    } else if (tokenType == "nftcard") {
      navigator.clipboard.writeText(
        nftLink
          ? " I am a proud owner of this NFT. " + "\n" + nftLink
          : nftCardUrl
      );
    } else if (tokenType == "giftRefLink") {
      navigator.clipboard.writeText(
        nftLink
          ? "NFT waali Diwali!✨🪔" +
              "\n" +
              "\n" +
              "This festive season gift FanTiger exclusive music NFTs💰 and get 1 FREE song NFT." +
              "\n" +
              "\n" +
              "You have received a gift. Accept your Song NFT Gift Now!🎁" +
              "\n" +
              "\n" +
              "This gift link is valid till" +
              " " +
              giftLinkexpire +
              "\n" +
              nftLink
          : nftCardUrl
      );
    } else {
      navigator.clipboard.writeText(nftLink ? nftLink : nftCardUrl);
    }
    const tagManagerArgs = {
      dataLayer: {
        event: "tokenShared",
        tokenName: tokenName,
        tokenCategory: tokenCategory,
        tokenPrice: tokenPrice,
        tokenOwnership: tokenOwnership,
        shareMethod: "Copy Link",
      },
    };
    TagManager.dataLayer(tagManagerArgs);
    setCopied(true);
  };

  // console.log('random',buttonPropsSecond)
  return (
    // <div style={{ position: "relative" }}>
    //   <TwitterShareButton {...buttonPropsSecond}>
    //     <TwitterIcon {...iconProps} />
    //   </TwitterShareButton>
    //   <FacebookShareButton {...buttonProps}>
    //     <FacebookIcon {...iconProps} />
    //   </FacebookShareButton>
    //   <LinkedinShareButton {...buttonProps}>
    //     <LinkedinIcon {...iconProps} />
    //   </LinkedinShareButton>
    //   <WhatsappShareButton {...buttonPropsSecond}>
    //     <WhatsappIcon {...iconProps} />
    //   </WhatsappShareButton>
    //   <TelegramShareButton
    //     url={
    //       "Join the Music Revolution in India!\nJoin FanTiger!\n" +
    //       get(props, "shareLink", "https://t.me/FanTigerIndia")
    //     }
    //     style={{ marginLeft: "15px" }}
    //   >
    //     <TelegramIcon {...iconProps} />
    //   </TelegramShareButton>
    //   <TumblrShareButton {...buttonProps}>
    //     <TumblrIcon {...iconProps} />
    //   </TumblrShareButton>
    //   <EmailShareButton {...buttonPropsSecond}>
    //     <EmailIcon {...iconProps} />
    //   </EmailShareButton>
    // </div>

    <List sx={songStyle.socialShareinglist} style={style}>
      <ListItem>
        <WhatsappShareButton {...buttonPropsSecond}>
          <Link>
            <Box
              sx={{ cursor: "pointer" }}
              component="img"
              src="/images/songdetails/whatsapplogo.svg"
            />
            <Typography onClick={() => handleShared("Whatsapp")} component="p">
              Whatsapp
            </Typography>
          </Link>
        </WhatsappShareButton>
      </ListItem>

      <ListItem>
        <TelegramShareButton
          url={nftLink ? refLinkText + nftLink : refLinkText + nftCardUrl}
        >
          <Link>
            <Box
              component="img"
              src="/images/songdetails/telegramlogo.svg"
              sx={{ cursor: "pointer" }}
            />
            <Typography onClick={() => handleShared("Telegram")} component="p">
              Telegram
            </Typography>
          </Link>
        </TelegramShareButton>
      </ListItem>

      <ListItem>
        <FacebookShareButton {...buttonProps}>
          <Link>
            <Box
              component="img"
              src="/images/songdetails/fblogo.svg"
              sx={{ cursor: "pointer" }}
            />
            <Typography onClick={() => handleShared("Facebook")} component="p">
              Facebook
            </Typography>
          </Link>
        </FacebookShareButton>
      </ListItem>

      {/* <ListItem sx={{ cursor: "pointer" }}>
        <Link>
          <Box component="img" src="/images/songdetails/instalogo.svg" />
          <Typography component="p">Insagram</Typography>
        </Link>
      </ListItem> */}

      <ListItem>
        <TwitterShareButton {...buttonPropsSecond}>
          <Link>
            <Box
              component="img"
              src="/images/songdetails/twitterlogo.svg"
              sx={{ cursor: "pointer" }}
            />
            <Typography onClick={() => handleShared("Twitter")} component="p">
              Twitter
            </Typography>
          </Link>
        </TwitterShareButton>
      </ListItem>

      <ListItem sx={{ cursor: "pointer" }}>
        <Link onClick={(e) => copyToClipboard(e)}>
          <Box component="img" src="/images/songdetails/copylogo.svg" />
          <Typography component="p">Copy Link</Typography>
        </Link>
      </ListItem>
    </List>
  );
}
